import type { IReporte } from "../../modulos/reportes/interfaces";
import { IconTool } from '@tabler/icons-react';

export const listaReportesCliente: IReporte[] = [
    {
        slug: 'visitas-emergencias-mantenimientos',
        nombre: 'Visitas Emergencias y Mantenimientos',
        descripcion: 'Resumen de visitas y servicios realizados',
        icono: <IconTool size={18} />,
        url: 'https://app.powerbi.com/view?r=eyJrIjoiZjg4ODdiMzYtMzk0MC00ZTJhLWJkNWEtMzM0NjA1ODI3NDhlIiwidCI6IjE1NGZmODBlLThmZjQtNGVhMy1iZDkxLTgwODUyNWU5ZjQwNSJ9'
    }
];